// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a7cbadd4","239":"dda8246a","455":"999b518c","488":"efd8fe4f"}[chunkId] + ".chunk.js";
};